const join = (items, lang, conjunction = ", ") =>
	!Array.isArray(items) ? items : items.join(conjunction);

export default join;
